(function () {
  var form = document.getElementById('bd-capture-form');
  if (!form) return;
  var msg = document.getElementById('bd-msg');
  var btn = document.getElementById('bd-submit');

  function set(text, kind) {
    msg.textContent = text || '';
    msg.className = 'bd-capture__msg' + (kind ? ' bd-capture__msg--' + kind : '');
  }
  function done(html) { form.innerHTML = html; }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if ((document.getElementById('bd-hp') || {}).value) return; // honeypot tripped

    var month = parseInt(document.getElementById('bd-month').value, 10);
    var day = parseInt(document.getElementById('bd-day').value, 10);
    var year = parseInt(document.getElementById('bd-year').value, 10);
    if (!month || !day || !year) { set('Please select your full birthday: month, day, and year.', 'error'); return; }

    var dt = new Date(Date.UTC(year, month - 1, day));
    if (dt.getUTCFullYear() !== year || dt.getUTCMonth() !== month - 1 || dt.getUTCDate() !== day || dt.getTime() > Date.now()) {
      set("That date doesn't look right. Please check it.", 'error'); return;
    }

    btn.disabled = true; set('Saving…');
    fetch('/apps/atari-birthday/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ year: year, month: month, day: day })
    })
      .then(function (r) { return r.json().then(function (d) { return { status: r.status, d: d }; }); })
      .then(function (res) {
        var d = res.d || {};
        if (d.ok) {
          if (d.coppa_minor) { done('<h2 class="bd-capture__heading">Thanks!</h2><p class="bd-capture__sub">Your birthday has been saved.</p>'); return; }
          var pts = d.points_granted ? ' You earned <strong>50 Atari Club points</strong>!' : '';
          done('<h2 class="bd-capture__heading">Birthday saved 🎉</h2><p class="bd-capture__sub">Thanks!' + pts + '</p>');
          return;
        }
        btn.disabled = false;
        var m = ({
          invalid_date_of_birth: "That date doesn't look right. Please check it.",
          not_logged_in: 'Please log in first, then try again.',
          bad_signature: 'We couldn’t verify your session. Please refresh and try again.',
          rate_limited: 'One moment, please try again in a few seconds.',
          customer_not_found: "We couldn't find your account. Please refresh and try again."
        })[d.error] || 'Sorry, something went wrong. Please try again.';
        set(m, 'error');
      })
      .catch(function () { btn.disabled = false; set('Network error. Please try again.', 'error'); });
  });
})();
